<template>

    <div class="position-relative">
      <!-- shape Hero -->
      <section style="margin-top:140px">
        <div class="container">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/solutions/digitalinfrastructure"
                  >Digital Infrastructure</router-link
                >
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Analytics
              </li>
            </ol>
          </nav>

          <div class="row">
            <div class="col-lg-8">
              <h2 class="title">Analytics</h2>
              <p class="lead">
                Data analytics is vital to decision-making for growing
                businesses and established businesses. However, decisions made
                with conventional wisdom not utilizing available data and
                resources are insufficient and detrimental to business success.
                Also, with the increasing rate and frequency of data,
                organizations need to automate and simplify data analysis for
                them to make timely decisions and be more competitive.
              </p>
              <p class="lead">
                Data Analytics solutions help businesses take in data from many
                sources, allowing them to ask questions and get meaningful
                answers. When clients modernize legacy equipment and deploy a
                data analytics strategy, both operational benefits and a better
                end-user experience for their clients can be achieved.
              </p>
              <p class="lead">
                We offer help to customers leveraging on data, not just from
                traditional sources. Still, rich new sources such as social,
                sensors, machines, and other Internet of Things (IoT) devices to
                assist them in reaching their goals. However, with the aid of
                analytics a wide range of application use cases, organizations
                must set thoughtful goals around analytics, develop data science
                best practices and choose the right technology to provide
                quality insights
              </p>
              <p class="lead">
                Our Data analytics solutions include
              </p>
              <div>
                <h5>Data Acquisition</h5>
                <p>
                  We can help you get the data you need from every possible
                  source to help you take timely and thoughtful decisions to
                  grow your business.
                </p>
                <h5>Data Assessments</h5>
                <p>
                  Understanding your current state and future state environments
                  need not be challenging. We can analyze workflows, people,
                  processes and tools to make sure you are positioned with a
                  strategy and roadmap to serve you well into the future. This
                  includes benchmarking to competitors, recommendations and next
                  steps, analyzing the maturity and risks of technology and
                  prioritization and opportunity grids.
                </p>
                <h5>Data Monetization</h5>
                <p>
                  We can help businesses understand ways in which they treat
                  their data either as an asset generating new streams of
                  revenue that incorporate predictive analytics or as a
                  liability.
                </p>
                <h5>Dashboards</h5>
                <p>
                  We can build a clear, concise dashboard which will give you
                  all the essential data you need, in the way you wish to see
                  it, on all the devices you need it on.
                </p>
                <h5>Data Migrations</h5>
                <p>
                  Adopting new technology does not need to disrupt your
                  business. Allow us to take over the tasks of migrating your
                  data from the legacy landscape to the future landscape so your
                  valuable resources can focus on taking advantage of your new
                  investment.
                </p>
                <h5>Data Integrations</h5>
                <p>
                  Whether consolidating data from multiple systems to reduce
                  operational complexity and costs or combining systems acquired
                  through mergers and acquisitions, Universal Tech LLC can make
                  sure all your data is being integrated into the business and
                  being used to its maximum potential.
                </p>
                <h5>Data Warehouse Optimization</h5>
                <p>
                  Some data needs to be fast and available in real-time; other
                  data may need to be stored in a for cost-effective.
                  Regardless, you want all of your data working for you without
                  the complex tasks
                  of manually moving data around or switching between tools and processes.
                  UniversalTech LLC can automate the tasks of moving data between
                  right-sized environments while making the experience seamless
                  to the end-user.
                </p>
              </div>

         
            </div>
     <div class="col-lg-4">
                <DigitalInfraSideNav></DigitalInfraSideNav>
              </div>
        </div>
        </div>
      </section>
    </div>

</template>
<script>
import DigitalInfraSideNav from "./DigitalInfraSideNav";
export default {
  name: "overview",
  components: {
    DigitalInfraSideNav,
  },
};
</script>
<style>
.shape-container {
  padding-bottom: 5rem;
}
</style>
